import { Component } from '@angular/core';

@Component({
  selector: 'app-process-section',
  standalone: true,
  templateUrl: './process-section.component.html',
  styleUrl: './process-section.component.scss'
})
export class ProcessSectionComponent {}

